// extracted by mini-css-extract-plugin
module.exports = {"Carousel":"Carousel_Carousel__3Stxr","ImageContainer":"Carousel_ImageContainer__k7JEe","Caption":"Carousel_Caption__36pLU"};